import { render, staticRenderFns } from "./Individuals.vue?vue&type=template&id=717e0f24&"
import script from "./Individuals.vue?vue&type=script&lang=js&"
export * from "./Individuals.vue?vue&type=script&lang=js&"
import style0 from "./Individuals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports